const $ = jQuery.noConflict();

class MobileHeader {
	constructor(
		trigger = '.main-header__hamburger',
		pbody = 'body',
		listParent = '.menu-item-has-children > a, .menu-item-has-children > button'
	) {
		this.trigger = trigger;
		this.pbody = pbody;
		this.listParent = listParent;
	}
	init() {
		$(this.trigger).on('click', this.setNavState);
		$(this.listParent).on('click', this.setListState);
	}
	setNavState(e) {
		e.preventDefault();
		const body = $('body');

		if ($(this).hasClass('open')) {
			MobileHeader.hideWrapper(this, body);
		} else {
			MobileHeader.showWrapper(this, body);
		}
	}
	setListState(e) {
		e.preventDefault();

		if (!$(this).hasClass('open')) {
			$('body').addClass('mega-menu-open');
			$(
				'.main-header__primary-nav a.open, .main-header__primary-nav button.open'
			).removeClass('open');
			$(this).addClass('open');
			$('.main-header__nav').scrollTop(0);
			$('.main-header__nav').addClass('sub-menu-open');
			$('.main-header__logo').addClass('sub-menu-open');

			if (1200 <= window.innerWidth) {
				// this is desktop
				const viewportOffset = document
					.querySelector('.main-header__container')
					.getBoundingClientRect();
				$('.main-header__primary-nav > ul > li > .sub-menu').css(
					'top',
					viewportOffset.bottom
				);
			}
		} else {
			$('body').removeClass('mega-menu-open');
			$(this).removeClass('open');
			$('.main-header__nav').removeClass('sub-menu-open');
			$('.main-header__logo').removeClass('sub-menu-open');
		}
	}
	static hideWrapper(el, body) {
		if (1200 > window.innerWidth) {
			// this is mobile
			$('.main-header__nav').css('top', 36);
			$('.main-header__nav-bg').css('top', 36);
			$('.main-header__primary-nav > ul > li > .sub-menu').css('top', 96);
		}

		$(el).removeClass('open');
		body.removeClass('overlayed');
		body.removeClass('mobile-menu-open');
		$('.main-header__nav').removeClass('sub-menu-open');
		$('.main-header__nav').find('.open').removeClass('open');
		$('.main-header__logo').removeClass('sub-menu-open');
		$(el).next().removeClass('active');
	}
	static showWrapper(el, body) {
		if (1200 > window.innerWidth) {
			// this is mobile
			const viewportOffset = document
				.querySelector('.main-header__container')
				.getBoundingClientRect();
			$('.main-header__nav').css('top', viewportOffset.top);
			$('.main-header__nav').scrollTop(0);
			$('.main-header__nav-bg').css('top', viewportOffset.top);
			$('.main-header__primary-nav > ul > li > .sub-menu').css(
				'top',
				viewportOffset.bottom
			);
		}

		$(el).addClass('open');
		body.addClass('overlayed');
		body.addClass('mobile-menu-open');
		$(el).next().addClass('active');
	}
	resized() {
		if (
			!$(this.trigger).is(':visible') &&
			$(this.trigger).hasClass('open')
		) {
			MobileHeader.hideWrapper(this.trigger, $(this.pbody));
		}
	}
	hideOutsideClick(e) {
		if (
			!e.target.closest('.main-header') ||
			$(e.target).hasClass('mega-menu-background')
		) {
			$('body').removeClass('mega-menu-open');
			MobileHeader.hideWrapper(this.trigger, $(this.pbody));
		}
		// if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
		// 	const container = $('.main-header');
		// 	if (
		// 		!container.is(e.target) &&
		// 		container.has(e.target).length === 0
		// 	) {

		// 	}
		// }
	}
}

export default MobileHeader;
